import React, { useState, useEffect,useContext } from 'react';
import '../../styles/filing.css'
import { Link, useNavigate,useParams  } from 'react-router-dom';
import DynamicIcon from '../../components/dynamicicon';




import { ShareContext } from '../../context/ShareContext';

import * as Constants from '../../constants';
import * as Services from '../../services';
import JisDialog from '../../components/dialog';
import Gazette from '../../components/core/gazette';
import BackLoader from '../../components/backloader';

import JisYesNo from '../../components/controls/jisYesNo';
import JisParty from '../../components/controls/jisparty';
import PdfViewer from '../../components/controls/pdfviewer';
import MultiSelectDropdown from '../../components/controls/multiselectdropdown';
import JisTabButton from '../../components/controls/jisTabButton';
import JisButton from '../../components/controls/jisButton';
import JisCheckbox from '../../components/controls/jisCheckbox';
import JisDialogForm from '../../components/formdialog';
import { ChevronDown } from 'lucide-react';


function Historical_Case() {
    const navigate = useNavigate();
 const { caseid } = useParams();
 const FeeTYPEID=1;
const {  activePage, token, profile, setIsExpired, setAlert,frequentData} = useContext(ShareContext);
const [cinfo, setCase] =useState({stateId:Constants.Default_State,processType:'Normal',isPublic:1,
         caseFilingId:1,isDelarative:true,isRequireInterpretation :true,
    isLegalPolicy:true, isLegalPosition:true,isEmergency: true,isDispute : true, isUniform: true
     });
     
    const [flow, setFlow] = useState({pos:1, code:"case_details"});
    const [flowerror, setFlowError]=useState('');
    const [isSuccess, setIsSuccess]= useState(false);
    const [causeOfActions, setCauseOfActions]=useState([]);
    const [isVacation, setIsVacation] = useState(false);
    const [isSaved, setIsSaved]= useState(false);
    const [savedTitle, setSavedTitle]=useState('');
    const [selectedCauses, setSelectedCauses] = useState([]);

    const [otherCauses, setOtherCauses] = useState([]);
    const [removingIndex, setRemovingIndex] = useState(null);
    const [casefees, setCaseFees] = useState([]); //this is the amount created to be sent to Pay4It 
    const [isFiat, setIsFiat]=useState(false);
    const [fiat, setFiat] = useState(null);
    const [fiatUrl, setFiatUrl] =useState('')
    const [isPreview, setIsPreview] = useState(false);
   
    const [states, setStates] =useState([]);
    const [Lga, setLga] = useState([]);
    const [cities, setCities] = useState([]);
 
    const [loading, setLoading] = useState(false);
    const [legal, setLegal]= useState({});
    const [showLegals, setShowLegals] = useState(false);
    const [claims, setClaims] = useState([{ claim:'',claimValue:'',currencyType:'' }]);
    const [parties,setParties] = useState([]);
    const [party, setParty] = useState({id:0, isOrg:"0", isLeadParty:true, state:Constants.Default_State, partyTypeId:''});
    const [motions,setMotions] = useState([]);
    const [motion, setMotion] =useState([]);
    const [motionPrayers, setPrayers] = useState([{prayer:''}]);
    const [partyOptions, setPartyOptions] = useState([]);

    const [locs, setLocs]=useState({state:null,lga:null,city:null})

    const [isNewFiat, setNewFiat]=useState(true);
    const [casefeeId, setcasefeeId] = useState(null)
    const [tab, setTab] = useState("caseinfo");
    const [documents, setDocuments] = useState([]);
    const [claim, setClaim] = useState({id:0});
    const [previewUrl, setPreviewUrl] = useState(false);
    const [openParty, setOpenParty] = useState(false)
    const [changeNumber, setChangeNumber] = useState({oldCaseNumber:'',newCaseNumber:''})
    const [isChange, setIsChange]=useState(false);
    const [changeStatus, setChangeStatus] =useState({oldStatus:'',newStatus:''});
    const [isStatus, setIsStatus]=useState(false);
    // Case State tab: IsActive / IsConcluded toggles
    const [caseFlags, setCaseFlags] = useState({ isActive: "", isConcluded: "", reason: "" });
    const [isFlags, setIsFlags] = useState(false);
    const [flagError, setFlagError] = useState("");
    // Upload Options tab: reverse the document upload option chosen by the filer
    const [uploadFees, setUploadFees] = useState([]);
    const [resetLine, setResetLine] = useState(null);
    const [resetReason, setResetReason] = useState("");
    const [resetError, setResetError] = useState("");
    const [isDocument, setIsDocument]=useState(false);
    const [doc, setDoc] = useState(null);
    const pagecode="casedetails";
    const [page,setPage] = useState(null);
    const [isNewCaseNumber, setIsNewCaseNumber] = useState(null);
    const [uplines, setUplines] = useState([]);
    const [openClaim, setOpenClaim] = useState(false);
    const [openMotion, setOpenMotion] = useState(false);

    const processmode=[
        {label:'Normal',value:'Normal'},
        {label:'Fast Track', value:'Fast Track'},
        {label:'Urgency', value:'Urgency'}
    ]

    const partydes=[
        {label:'Individual', value:0},
        {label:'Organization',value:1},

    ]

    const idModes=[
        {label:'Passport',value:'Passport'},
        {label:'National ID', value:'National ID'},
        {label:'Driving Licence', value:'Driving Licence'},
        {label:'Others', value:'Others'}
    ]

 const caseidentity=[
        {label:'Public',value:1},
        {label:'Private', value:0},
    ]
   const currencies=[
        {label:'Naira (N)',value:"Naira" },
        {label:'Dollar ($)', value:"Dollar"},
        {label:'Euro (e)', value:"Euro"},
    ]  




 async function loadPage() {
    const _data = await Constants.onScreenDetails(pagecode,token);
    setPage(_data);
  }  


    useEffect(() => {
       
    onLoad();
    loadPage();
    if(caseid){
        onLoadCase(caseid);
    }
    onGetStates();

        
    }, [])
useEffect(() => {

setLegal({id:profile?.id, name: `${profile?.firstName} ${profile?.lastName??''}`})
    
}, [profile])

useEffect(() => {

setSelectedCauses([])
    
}, [cinfo.caseCategoryId])



useEffect(() => {
    if(cinfo.stateId){
        onGetLgs(cinfo.stateId);
    }  
}, [cinfo.stateId])



useEffect(() => {
    if(cinfo.LocalGovtAreaId){
    onGetCities(cinfo.LocalGovtAreaId);
    }     
}, [cinfo.LocalGovtAreaId])





 const onGetStates= async()=>{
        const c=await Services.onGetStates(); 
        setStates(c);
}

useEffect(() => {
    if(cinfo.caseCategoryId){
    onGetCauseOfAction(cinfo.caseCategoryId)
    }     
}, [cinfo.caseCategoryId])

useEffect(() => {
   console.log('the use state fiat');
   console.log(fiat);    
}, [fiat])

const onGetCauseOfAction= async(id)=>{
    //for account registration
    try {

        const resp = await fetch(`${Constants.apiUrl}/filing/caause-of-action-by-cat/${id}`, { 
          method: 'GET',  headers: {  'Content-Type': 'application/json','Authorization': '',}, });  
        const data = await resp.json();
      
       setCauseOfActions(data); 
      } catch (error) {
        setLocs({...locs,lga:null});
        console.error(error);   
      }
}

const onCloseLegals=()=>{
    setShowLegals(false);
}

const onLoad= async()=>{
    //for account registration
    try {
     // setLoading(true);
        const resp = await fetch(`${Constants.apiUrl}/filing/new-case-dropdown`, { 
          method: 'GET',  headers: {  'Content-Type': 'application/json','Authorization':  `Bearer ${token}`,}, });  
        const data = await resp.json();
       // setLoading(false);
      
          setIsVacation(data.isVacation);
      } catch (error) {
      //  setLoading(false);
        console.error(error);   
      }
}

const onLoadCase= async(cid)=>{
    //for account registration
    try {
      setLoading(true);
        const resp = await fetch(`${Constants.apiUrl}/filing/case-filing-admin/${cid}`, { 
          method: 'GET',  headers: {  'Content-Type': 'application/json','Authorization':  `Bearer ${token}`,}, });  
        const data = await resp.json();
       setLoading(false);
        if(data.code==0){
            //caseinfo,parties, claims, causes
           var caseOptions={};
            if(data.caseinfo.caseOptions!=null){
              caseOptions=JSON.parse(data.caseinfo.caseOptions);
            }
             setCase({...data.caseinfo,...caseOptions});
             setCaseFlags({
               isActive: data.caseinfo.isActive ? "yes" : "no",
               isConcluded: data.caseinfo.isConcluded ? "yes" : "no",
               reason: "",
             });

            setParties(data.parties);

            setOtherCauses(data.causes);
            setMotions(data.motions);
            if(data.fiat){
                setNewFiat(false);
                setIsFiat(true);
                setFiatUrl(Constants.AbsoluteFiletoRelative(data.fiat.doc) );
                console.log(Constants.AbsoluteFiletoRelative(data.fiat.doc));
                setFiat({...data.fiat,filename:"Fiat on Record"});
                console.log('set Fiat')
            }
            setClaims(data.claims);
            setDocuments(data.documents);

            if(data.fee.length>0){
                    setcasefeeId(data.fee[0].id)
                }

   
        }
        else if(data.code==-10){
            setIsExpired(true);
        }

      } catch (error) {
        setLoading(false);
        console.error(error);   
      }
}

const onRemoveCause= async(id)=>{
    //for account registration
    try {
      setLoading(true);
        const resp = await fetch(`${Constants.apiUrl}/filing/remove-cause/${id}`, { 
          method: 'POST',  headers: {  'Content-Type': 'application/json','Authorization':  `Bearer ${token}`,}, });  
        const data = await resp.json();
       setLoading(false);
        if(data.code==0){
            //caseinfo,parties, claims, causes
           console.log(data);
        } else if(data.code==-10){
                      setIsExpired(true);
                  }

      } catch (error) {
        setLoading(false);
        console.error(error);   
      }
}

const onAddNewParty=()=>{
  setOpenParty(true);
   setParty({id:0, isOrg:"0", isLeadParty:true, state:Constants.Default_State, partyTypeId:''})
}

const onRemoveParty_Server= async(id)=>{
    //for account registration
    try {
      setLoading(true);
        const resp = await fetch(`${Constants.apiUrl}/filing/remove-party/${id}`, { 
          method: 'POST',  headers: {  'Content-Type': 'application/json','Authorization':  `Bearer ${token}`,}, });  
        const data = await resp.json();
       setLoading(false);
        if(data.code==0){
            //caseinfo,parties, claims, causes
           console.log(data);
        } else if(data.code==-10){
                      setIsExpired(true);
                  }

      } catch (error) {
        setLoading(false);
        console.error(error);   
      }
}
const onRemoveClaim_Server= async(id)=>{
    //for account registration
    try {
      setLoading(true);
        const resp = await fetch(`${Constants.apiUrl}/filing/remove-claim/${id}`, { 
          method: 'POST',  headers: {  'Content-Type': 'application/json','Authorization':  `Bearer ${token}`,}, });  
        const data = await resp.json();
       setLoading(false);
        if(data.code==0){
            //caseinfo,parties, claims, causes
           console.log(data);
        } else if(data.code==-10){
                      setIsExpired(true);
                  }

      } catch (error) {
        setLoading(false);
        console.error(error);   
      }
}

const onGetLgs= async(stateid)=>{
    //for account registration
    try {
        setLocs({...locs,lga:false});
        const resp = await fetch(`${Constants.apiUrl}/profile/lgs/${stateid}`, { 
          method: 'GET',  headers: {  'Content-Type': 'application/json','Authorization': '',}, });  
        const data = await resp.json();
       setLga(data);
        setLocs({...locs,lga:true});
       
      } catch (error) {
        setLocs({...locs,lga:null});
        console.error(error);   
      }
}

const onGetCities= async(lgid)=>{
    //for account registration
    try {
       setLocs({...locs,city:false});
       
        const resp = await fetch(`${Constants.apiUrl}/profile/cities/${lgid}`, { 
          method: 'GET',  headers: {  'Content-Type': 'application/json','Authorization': '',}, });  
        const data = await resp.json();
       setCities(data);
       setLocs({...locs,city:true});
       
      } catch (error) {
        setLocs({...locs,city:null});
        console.error(error);   
      }
}


 const onCaseChange = (e) => {
    setCase({...cinfo, [e.target.name]: e.target.value})
}


const onChangeOtherCause = (index, key, value) => {

  setOtherCauses(prev =>
    prev.map((item, i) => i === index ? { ...item, [key]: value } : item)
  );
};

const onRemoveOtherCause = async(index) => {
   
     setRemovingIndex(index);
     //check if object has an id
     const h=otherCauses[index];
     if(h.id>0){
        await onRemoveCause(h.id);
     }
  setTimeout(() => {
    setOtherCauses(prev => prev.filter((_, i) => i !== index));
    setRemovingIndex(null);
  }, 300); // match fadeOut duration

 
};

const onAddOtherCause = () => {
  setOtherCauses(prev => [...prev, {id:0, description:'',}]);
};


const onRemoveParty =async (index) => {
   
    const h=parties[index];
        if(h && h.id>0){
            await onRemoveParty_Server(h.id);
        }
     setRemovingIndex(index);
/*   setTimeout(() => {
    setParties(prev => prev.filter((_, i) => i !== index));
    setRemovingIndex(null);
  }, 300); // match fadeOut duration */

 
};

const onEditParty=(row,index) =>{
    setOpenParty(true);
      setParty(row);
  }

  const onEditClaim=(row,index) =>{
   
      setClaim(row);
      setOpenClaim(true);
  }

  const onCancelAction=(type)=>{
    if(type=="claim"){
        setClaim({id:0});
        setOpenClaim(false);
    }else if(type=="motion"){
        setMotion({id:0});
        setOpenMotion(false);
    }else if(type=="party"){
        setParty({id:0});
        setOpenParty(false);
    }
  }

  const onSave=async (e)=>{

      e.preventDefault();
    
  if(isFiat && fiat==null){
      setFlowError('Please select the FIAT document for upload.')
          return
  }
      if(!(selectedCauses.length>0 || otherCauses.length>0))
      {
          setFlowError('Please select one of the causes or enter other causes')
          return
      }
  setFlowError('')
      const caseOptions ={isDelarative:cinfo.isDelarative,isRequireInterpretation :cinfo.isRequireInterpretation,
      isLegalPolicy:cinfo.isLegalPolicy, isLegalPosition: cinfo.isLegalPosition,isEmergency: cinfo.isEmergency,isDispute : cinfo.isDispute, isUniform: cinfo.isUniform
      }
      
      var caseFilingId=1;
  console.log('the printed options');
  console.log(caseOptions);
     /*  const hasAnyFalse = Object.values(caseOptions).some(v => v === false);
      if (hasAnyFalse) {
          caseFilingId=2;
      console.log("At least one option is false. meanning its ADR");
      } */
      var caseinfo={...cinfo,caseOptions:JSON.stringify(caseOptions), isPublic:cinfo.isPublic=='1'?true:false};
      var _fiat=null;
      if( isNewFiat){
          var _fiat={doc:fiat?.base64,isPay:true};
      }
      //isPay is just to brng in file

      const stringObjects = otherCauses?.map(oc => ({
              id:oc.id,
              causedId: oc.causeId,
              description: oc.description}));

      //var _othercauses= otherCauses;
      var _causes= [...selectedCauses,...stringObjects];

    
      var casefiling={cinfo:caseinfo,fiat:_fiat,causes:_causes
        
      }

      //make sure the motion is order49
      

    setLoading(true)
          try {
            
            const resp = await fetch(`${Constants.apiUrl}/filing/admin-update/${caseid}`, {
              method: 'POST',
              body:JSON.stringify(casefiling) ,
              headers: {
                'Content-Type': 'application/json, text/plain',
                Authorization: `Bearer ${token}`,
              },
            });
            
            const data = await resp.json();
            setLoading(false);

        //   setFlow({pos:6,code:"congrat"})
        localStorage.removeItem('caseinfo');
        
        if(data.code==0){
        // setIsSuccess(true);
        //process the flow and update the field.
        setIsSaved(true)
        setSavedTitle("Update Case Details")
        
        }
          else if(data.code==-10){
                        setIsExpired(true);
                    }
        else{
          console.log(data);
          console.log(data.status);
          setFlowError(data.satus)
        }
            
            
          } catch (error) {
            setLoading(false);
            console.error(error);
            setFlowError('cannot connect to the server at the moment. Try again')
          // onMove();
          }
  }



  const onChangeClaim = (e) => {
  setClaim({...claim, [e.target.name]: e.target.value})
  };

  const onRemoveClaims = async (index) => {
      if(claims.length==1){
          return;
      }

      const h=claims[index];
          if(h && h.id>0){
              await onRemoveClaim_Server(h.id);
          }
      setRemovingIndex(index);
    setTimeout(() => {
      setClaims(prev => prev.filter((_, i) => i !== index));
      setRemovingIndex(null);
    }, 300); // match fadeOut duration

  
  };


  const onChangePrayer = (index, key, value) => {
    setPrayers(prev =>
      prev.map((item, i) => i === index ? { ...item, [key]: value } : item)
    );
  };

  const onRemovePrayer = async(index) => {
      if(motionPrayers.length==1){
          return;
      }
    const h=motionPrayers[index];
          if(h && h.id>0){
              await onRemovePrayer_Server(h.id);
          }
      setRemovingIndex(index);
    setTimeout(() => {
      setPrayers(prev => prev.filter((_, i) => i !== index));
      setRemovingIndex(null);
    }, 300); // match fadeOut duration

  
  };
  const onRemovePrayer_Server= async(id)=>{
    //for account registration
    try {
      setLoading(true);
        const resp = await fetch(`${Constants.apiUrl}/filing/remove-prayer/${id}`, { 
          method: 'POST',  headers: {  'Content-Type': 'application/json','Authorization':  `Bearer ${token}`,}, });  
        const data = await resp.json();
       setLoading(false);
        if(data.code==0){
            //caseinfo,parties, claims, causes
           console.log(data);
        }
         else if(data.code==-10){
                      setIsExpired(true);
                  }

      } catch (error) {
        setLoading(false);
        console.error(error);   
      }
  }

const onAddPrayer = () => {
  setPrayers(prev => [...prev, { prayer: '',id:0 }]);
};

const onMotionChange = (e) => {
    setMotion({...motion, [e.target.name]: e.target.value})
    
}


 const onRemoveMotion_Server= async(id)=>{
    //for account registration
    try {
      setLoading(true);
        const resp = await fetch(`${Constants.apiUrl}/filing/remove-motion/${id}`, { 
          method: 'POST',  headers: {  'Content-Type': 'application/json','Authorization':  `Bearer ${token}`,}, });  
        const data = await resp.json();
       setLoading(false);
        if(data.code==0){
            //caseinfo,parties, claims, causes
           console.log(data);
        } else if(data.code==-10){
                      setIsExpired(true);
                  }

      } catch (error) {
        setLoading(false);
        console.error(error);   
      }
}
const onRemoveMotion = async(index) => {
   
    const h=motionPrayers[index];
        if(h && h.id>0){
            await onRemoveMotion_Server(h.id);
        }
     setRemovingIndex(index);
  setTimeout(() => {
    setMotions(prev => prev.filter((_, i) => i !== index));
    setRemovingIndex(null);
  }, 300); // match fadeOut duration

 
};

const onEditMotion=(row,index) =>{
    setRemovingIndex(-1);
 

  //remove that one and allow it to be edited
      console.log(row);
  setMotion(row);
      setPrayers(row.prayers);
      setOpenMotion(true);
  }


    
 const handleUploadChange =async (e  ) => {
 
        const files = e.target.files;
       setFiatUrl(URL.createObjectURL(files[0]))
        console.log('file document');
        console.log(files[0]);
        var b64=await Constants.toBase64(files[0]);

        var objUline={ doc:files[0], base64: b64.split(',')[1], filename:Constants.ReduceFilename(files[0]?.name), base64Ext:b64.split(',')[0],isPay:true }; //using isPay to indicate new fiat
        setFiat(objUline);
        setNewFiat(true);
        onPreview(objUline);

    };

const onPreview= async(id,uline)=>{
        const uploadurl=`${Constants.apiUrl}/gazette/uploadDocument/preview/${id}`
        

       // var updateditems=new Set(items);
            // Sending the FormData using fetch
            setLoading(true);
            fetch(uploadurl, {
            method: 'POST',
            body: JSON.stringify(uline),
            headers: {
              'Content-Type': 'application/json',
              'Authorization': '',
            },
            })
            .then(response => response.json())
            .then(data => {
                setLoading(false);
                console.log('preview details');
                console.log(data);
                if(data.code==0){
                    //saved already
                    var updated={...uline,prev:data}
                  
                    
                } else if(data.code==-10){
                      setIsExpired(true);
                  }
            })
            .catch(error => {
                console.error('Error:', error);
                setLoading(false);
        });
    }

    const onSaveMotion = async (e) => {
       e.preventDefault();
   /*  if (motions.length == 0) {
      setFlowError("Please save the motion before continuing.");
      return;
    } */
    setLoading(true);

    try {
      const resp = await fetch(`${Constants.apiUrl}/filing/motion-admin/${caseid}`, {
        method: "POST",
        body: JSON.stringify({...motion,motionPrayers}),
        headers: {
          "Content-Type": "application/json, text/plain",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await resp.json();
      setLoading(false);
      console.log(data);
      if (data.code === 0) {
        setMotion({id:0});
        setOpenMotion(false);
        onLoadCase(caseid);
      } else {
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
      // setErr(Constants.serverErr);
      // onMove();
    }
  };
  const onSaveClaims = async (e) => {
      e.preventDefault();
  
      setLoading(true);
  
      try {
        const resp = await fetch(`${Constants.apiUrl}/filing/claim-admin/${caseid}`, {
          method: "POST",
          body: JSON.stringify(claim),
          headers: {
            "Content-Type": "application/json, text/plain",
            Authorization: `Bearer ${token}`,
          },
        });
  
        const data = await resp.json();
        setLoading(false);
        console.log(data);
        if (data.code === 0) {
    
          setClaim({id:0});
          setOpenClaim(false);
           onLoadCase(caseid);
        } else {
        }
      } catch (error) {
        setLoading(false);
        console.error(error);
        // setErr(Constants.serverErr);
        // onMove();
      }
    };
    const onSaveParty = async (e) => {
     // e.preventDefault();
  
      setLoading(true);
  
      try {
        const resp = await fetch(`${Constants.apiUrl}/filing/party/${caseid}`, {
          method: "POST",
          body: JSON.stringify(e),
          headers: {
            "Content-Type": "application/json, text/plain",
            Authorization: `Bearer ${token}`,
          },
        });
  
        const data = await resp.json();
        setLoading(false);
        console.log(data);
        if (data.code === 0) {
          //setGazettes(data.gazettes);
          //setFlow({ pos: 2, code: "gazette" });
          setParty({id:0});
           onLoadCase(caseid);
            setAlert({open:true, title:'Add Party', subtitle:'Party Added successfully'})
           setOpenParty(false);
        } else {
        }
      } catch (error) {
        setLoading(false);
        console.error(error);
        // setErr(Constants.serverErr);
        // onMove();
      }
    };
const onPreviewDoc = (docs) => {
    setIsPreview(true);
    console.log(docs);
    console.log("here is called");
    var finalpath = "";
    if (docs.documentLocation != null) {
      finalpath = Constants.RelativeFiletoRelative(
        Constants.getDocumentPath(docs)
      );

    } else {
      finalpath = `${Constants.baseurl}/template-live-document/${docs.id}`;
    }
    setPreviewUrl(finalpath);
    console.log("the final path");
    console.log(finalpath);
  };

  const onFilingClaim = () => {
    navigate(`/filing-claim/${cinfo?.caseId}`);
  };
   const onFilingMotion = () => {
    navigate(`/filing-motion/${cinfo?.caseId}`);
  };
   const onFilingDocument = () => {
    navigate(`/filing-document/${cinfo?.caseId}`);
  };

  const onChangeCaseNumber=async()=>{
      //old number must match the current number
      

     setLoading(true);
      var __i={...changeNumber,isManual:isNewCaseNumber}
      try {
        const resp = await fetch(`${Constants.apiUrl}/filing/admin-change-case-number/${caseid}`, {
          method: "POST",
          body: JSON.stringify(__i),
          headers: {
            "Content-Type": "application/json, text/plain",
            Authorization: `Bearer ${token}`,
          },
        });
  
        const data = await resp.json();
        setLoading(false);
        console.log(data);
        if (data.code === 0) {
          setIsChange(false);
          setChangeNumber({oldCaseNumber:'', newCaseNumber:''});
          setAlert({open:true, title:'Change Case Number', subtitle:`Case Number Changed successfully. New Number ${data.caseNumber}`})
           onLoadCase(caseid);
        } else {
          setIsChange(false);
           setAlert({open:true, title:'Change Case Number Issue', subtitle:data.status})
        }
      } catch (error) {
        setLoading(false);
        console.error(error);
      }
  }

  const onSubmitCaseNumber=(e)=>{
  e.preventDefault();
  if(changeNumber.oldCaseNumber!=cinfo.caseNumber){
       // alert("Old case number does not match the current case number");
        setAlert({open:true, title:'Change Case Number Issue', subtitle:'Old case number does not match the current case number'})
        return;
      }
  setIsChange(true);

  }

  const onChangeStatus=async()=>{
     setLoading(true);
  
      try {
        const resp = await fetch(`${Constants.apiUrl}/filing/admin-change-case-status/${caseid}`, {
          method: "POST",
          body: JSON.stringify({...changeStatus,oldStatus:cinfo?.caseStatusId}),
          headers: {
            "Content-Type": "application/json, text/plain",
            Authorization: `Bearer ${token}`,
          },
        });
  
        const data = await resp.json();
        setLoading(false);
        console.log(data);
        if (data.code === 0) {
          setIsStatus(false);
          setChangeStatus({oldStatus:0,newStatus:0});
          onLoadCase(caseid);

        } else {
          alert("cannot update");
        }
      } catch (error) {
        setLoading(false);
        console.error(error);
      }
  }
  const UPLOAD_OPTION_LABELS = {
    attest: "Already attested/commissioned",
    "not-attest": "To be attested/commissioned",
    template: "JIS template",
  };

  const onLoadUploadOptions = async () => {
    setLoading(true);
    try {
      const resp = await fetch(`${Constants.apiUrl}/filing/admin-upload-options/${caseid}`, {
        method: "GET",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
      });
      const data = await resp.json();
      setLoading(false);
      if (data.code === 0) setUploadFees(data.fees || []);
      else if (data.code == -10) setIsExpired(true);
      else setAlert({ open: true, title: "Upload Options", subtitle: data.status || "Unable to load documents" });
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  const onConfirmResetUpload = async () => {
    if (!resetReason.trim()) {
      setResetError("Please give a reason for the change");
      return;
    }
    setLoading(true);
    try {
      const resp = await fetch(`${Constants.apiUrl}/filing/admin-reset-upload-option/${resetLine.id}`, {
        method: "POST",
        body: JSON.stringify({ reason: resetReason.trim() }),
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
      });
      const data = await resp.json();
      setLoading(false);
      if (data.code === 0) {
        setResetLine(null);
        setResetReason("");
        setAlert({
          open: true,
          title: "Upload Option Reset",
          subtitle: "The filer can now select the correct upload option and upload the document again.",
        });
        onLoadUploadOptions();
      } else if (data.code == -10) {
        setIsExpired(true);
      } else {
        setResetError(data.status || "Unable to reset the upload option");
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
      setResetError(Constants.serverErr);
    }
  };

  const flagsChanged =
    caseFlags.isActive !== (cinfo?.isActive ? "yes" : "no") ||
    caseFlags.isConcluded !== (cinfo?.isConcluded ? "yes" : "no");

  const onSubmitCaseFlags = (e) => {
    e.preventDefault();
    setFlagError("");
    if (!flagsChanged) {
      setFlagError("Nothing has changed");
      return;
    }
    if (!caseFlags.reason.trim()) {
      setFlagError("Please give a reason for the change");
      return;
    }
    setIsFlags(true);
  };

  const onSaveCaseFlags = async () => {
    setIsFlags(false);
    setLoading(true);
    try {
      const resp = await fetch(`${Constants.apiUrl}/filing/admin-case-flags/${caseid}`, {
        method: "POST",
        body: JSON.stringify({
          isActive: caseFlags.isActive === "yes",
          isConcluded: caseFlags.isConcluded === "yes",
          reason: caseFlags.reason.trim(),
        }),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      const data = await resp.json();
      setLoading(false);
      if (data.code === 0) {
        setAlert({ open: true, title: "Case State", subtitle: "Case state updated successfully" });
        onLoadCase(caseid);
      } else if (data.code == -10) {
        setIsExpired(true);
      } else {
        setFlagError(data.status || "Unable to update the case state");
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
      setFlagError(Constants.serverErr);
    }
  };

  const onSubmitCaseStatus=(e)=>{
  e.preventDefault();
  setIsStatus(true);
  }

  const PrepareDocumentRemove=(opt)=>{
    setDoc(opt);
    setIsDocument(true);
  }
  const onRemoveDocument=async()=>{
     setLoading(true);
  
      try {
        const resp = await fetch(`${Constants.apiUrl}/filing/toggle-document-visibility/${caseid}/${doc?.id}`, {
          method: "POST",
          //body: JSON.stringify({...changeStatus,oldStatus:cinfo?.caseStatusId}),
          headers: {
            "Content-Type": "application/json, text/plain",
            Authorization: `Bearer ${token}`,
          },
        });
  
        const data = await resp.json();
        setLoading(false);
        console.log(data);
        if (data.code === 0) {
          
          setDoc(null);
          setIsDocument(false);
          onLoadCase(caseid);

        } else {
          alert("cannot update");
        }
      } catch (error) {
        setLoading(false);
        console.error(error);
      }
  }

  const onAddUpline=()=>{
    setUplines(prev => [...prev, {id:0, DocumentTitle:'', file:null}]);
  }
  const onRemoveUpline=(index)=>{
    setUplines(prev => prev.filter((_, i) => i !== index));
  }
const onChangeUpline=(index,key,value)=>{
  setUplines(prev =>
    prev.map((item, i) => i === index ? { ...item, [key]: value } : item)
  );
}

const onUploadUplines=async(e)=>{
  e.preventDefault();
  //save all base64 part of the string 

  const uploadurl = `${Constants.apiUrl}/filing/admin-uploadDocument/${caseid}`;
 const _uplines = await Promise.all(
    uplines.map(async (item) => {
      const b64 = await Constants.toBase64(item.file);
      const filename = Constants.ReduceFilename(item.file?.name);
      
      return {
        id: 0,
        uplineType: "",
        base64: b64.split(",")[1],
        base64Ext: b64.split(",")[0],
        title: item.DocumentTitle,
        partyId:item.partyId,
        filename: filename,
      };
    })
  );
setLoading(true);
    fetch(uploadurl, {
      method: "POST",
      body: JSON.stringify(_uplines),
      headers: {
        "Content-Type": "application/json, text/plain",
        Authorization: `Bearer ${token}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setLoading(false);
        if (data.code == 0) {
          //saved already
          setAlert({ open: true, title: "Upload Uplines", subtitle: "Uplines Uploaded successfully" });
         setUplines([]);
         onLoadCase(caseid);
        } else if (data.code == -10) {
          setIsExpired(true);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        setLoading(false);
      });
}

//claim
const on_claims = async (e) => {
    e.preventDefault();

    setLoading(true);

    try {
      const resp = await fetch(`${Constants.apiUrl}/filing/claim/${caseid}`, {
        method: "POST",
        body: JSON.stringify(claims),
        headers: {
          "Content-Type": "application/json, text/plain",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await resp.json();
      setLoading(false);
      console.log(data);
      if (data.code === 0) {
        //setGazettes(data.gazettes);
        setFlow({ pos: 2, code: "gazette" });
      } else {
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
      // setErr(Constants.serverErr);
      // onMove();
    }
  };
  const onAddClaim = () => {
    setClaims((prev) => [
      ...prev,
      { claim: "", claimValue: "", currencyType: "" },
    ]);
  };
//end claim
 const onNewClaim=()=>{
  setClaim({id:0});
setOpenClaim(true);
 }
//start motion
  const onNewMotion = ()=>{
    setMotion({id:0});
    setOpenMotion(true);
   setPrayers([{prayer:''}]) ;
  }

//end motion

  return (
    <div>
        <div style={{textAlign:'center'}}><h2>{cinfo?.caseTitle?.toUpperCase()}</h2>
        <h3>{cinfo.caseNumber??cinfo.referenceNumber}</h3>
        </div>
      <div className='tab_body'>
        
         <div  className='tab_section' style={{ display: 'flex',  marginBottom: '20px' }}>
            <JisTabButton code="caseinfo" isActive={tab=='caseinfo'}  title="Update Case Details" data={null} isRoleBased={false}  onClick={()=> setTab('caseinfo')}/>
            {cinfo.caseNumber &&  <>
            <JisTabButton code="caseno" isActive={tab=='caseno'}  title="Change Case Number" 
            data={null} isRoleBased={false}  onClick={()=> setTab('caseno')}/>
            <JisTabButton code="casestatus" isActive={tab=='casestatus'}  title="Change Case Status" 
            data={null} isRoleBased={false}  onClick={()=> setTab('casestatus')}/>
            </>
            }
           
            <JisTabButton code="caseclaims" isActive={tab=='caseclaims'}  title={cinfo.caseTypeId==2?"Update Offences":"Update Claims"} data={null} isRoleBased={false}  onClick={()=> setTab('caseclaims')}/>
            <JisTabButton code="casedocuments" isActive={tab=='casedocuments'}  title="Update Documents" data={null} isRoleBased={false}  onClick={()=> setTab('casedocuments')}/> 
            <JisTabButton code="motions" isActive={tab=='motions'}  title="Update Motions" data={null} isRoleBased={false}  onClick={()=> setTab('motions')}/>      
            <JisTabButton code="parties" isActive={tab=='parties'}  title="Update Parties" data={null} isRoleBased={false}  onClick={()=> setTab('parties')}/>  
            <JisTabButton code="caseflags" isActive={tab=='caseflags'}  title="Case State" data={null} isRoleBased={false}  onClick={()=> setTab('caseflags')}/>
            <JisTabButton code="uploadoptions" isActive={tab=='uploadoptions'}  title="Upload Options" data={null} isRoleBased={false}  onClick={()=> { setTab('uploadoptions'); onLoadUploadOptions(); }}/>
            
        </div>
      {tab=='caseinfo' && <div className='tab_view'>
        <form onSubmit={onSave}>
            <h2>FILING OF COURT PROCESS</h2>
        <div  className="input-group">
            <label>Parties to the Case  <span className="required">*</span> </label>
            <div className='input-wrapper'>
                <DynamicIcon iname="person_3" />
                <input placeholder='Parties to the Case' required={true} name="caseTitle" maxLength={300} value={cinfo.caseTitle?.toUpperCase()} onChange={onCaseChange}   />
            </div>
        </div>

        <div style={{display:'flex'}}>
            <div style={{flex:1}}> 
                <div  style={{display:'flex'}}>
                    
                <div className="select-group">
                  <label> Case Type <span className="required">*</span> </label>
                  <select name="caseTypeId" value={cinfo.caseTypeId} required={true} onChange={onCaseChange} >
                      <option value="">Select </option>
                      {frequentData?.casetype.map((opt) => (
                      <option key={opt.id} value={opt.id}>
                          {opt.caseType1}
                      </option>
                      ))}
                  </select>
                  </div>
                  <div className="select-group">
                  <label> Classification <span className="required">*</span> </label>
                  <select name="caseCategoryId" value={cinfo.caseCategoryId} required={true} onChange={onCaseChange} >
                      <option value="">Select </option>
                      {frequentData?.casecategories.filter(c => c.caseTypeId==cinfo.caseTypeId).map((opt) => (
                      <option key={opt.id} value={opt.id}>
                          {opt.categoryTitle}
                      </option>
                      ))}
                  </select>
                  </div>
                {cinfo.caseNumber &&  <div className="select-group">
                  <label> Sub Clasification  </label>
                  <select name="caseSubCatId" value={cinfo.caseSubCatId}  onChange={onCaseChange} >
                      <option value="">Select </option>
                      {frequentData?.subcats.filter(c => c.caseCategoryId==cinfo.caseCategoryId).map((opt) => (
                      <option key={opt.id} value={opt.id}>
                          {opt.description}-{opt.title}
                      </option>
                      ))}
                  </select>
                  </div>}  
                  

                </div>
               
                <div style={{display:'flex'}}>
                  <div className="select-group">
                  <label> Filing Type <span className="required">*</span> </label>
                  <select name="caseFilingId" value={cinfo.caseFilingId} required={true} onChange={onCaseChange} >
                      <option value="">Select </option>
                      {frequentData?.filingtypes.map((opt) => (
                      <option key={opt.id} value={opt.id}>
                          {opt.title}
                      </option>
                      ))}
                  </select>
                  </div>
                    <div className="select-group">
                            <label> Case Origin <span className="required">*</span> </label>
                            <select name="caseOriginId" value={cinfo.caseOriginId} required={true} onChange={onCaseChange} >
                                <option value="">Select </option>
                                {frequentData?.caseorigin.map((opt) => (
                                <option key={opt.id} value={opt.id}>
                                    {opt.title} {opt.id==3 && '(if this case was previously filed at Magistrate Court)'}
                                </option>
                                ))}
                            </select>
                            </div>
                  <div className="select-group">
                            <label> Mode of Process <span className="required">*</span> </label>
                            <select name="processType" value={cinfo.processType} required={true} onChange={onCaseChange} > 
                                {processmode.map((opt) => (
                                <option key={opt.value} value={opt.value}>
                                    {opt.label}
                                </option>
                                ))}
                                {isVacation && <option value="vacation">Vacation</option>}
                            </select>
                            </div>          
                </div>
                <div  style={{display:'flex'}}>
                   {cinfo.caseOriginId==3 && <div  className="input-group">
                        <label>Magistrate Suit/Charge Number <span className="required">*</span> </label>
                        <div className='input-wrapper'>
                            <DynamicIcon iname="group" />
                            <input placeholder='Magistrate Suit/Charge Number' required={true} name="oldCaseNumber"  value={cinfo.oldCaseNumber} onChange={onCaseChange}   />
                        </div>
                    </div>} 
                    

                </div>
                <div style={{display:'flex'}}>
                    <JisCheckbox label="Check this box if this case is being filed by a religious body" value={cinfo.IsReligious} onChange={(e)=>setCase({...cinfo, IsReligious:e})} />
                   {cinfo.IsReligious && 
                   
                   <div className="select-group">
                            <label> Religion Group <span className="required">*</span> </label>
                            <select required={true} name="religiousGroup" maxLength={50} value={cinfo.religiousGroup} onChange={onCaseChange}  >
                                <option value="">Select </option>
                                <option>Christanity</option>
                                <option>Islam</option>
                                <option>Traditional</option>
                                <option>Others</option>
                            </select>
                            </div>
                   } 
                </div>
                {cinfo.IsReligious && <div  className="input-group">
                        <label>Religious Name <span className="required">*</span> </label>
                        <div className='input-wrapper'>
                            <DynamicIcon iname="group" />
                            <input placeholder='Religious Name' required={true} name="religiousName" maxLength={50} value={cinfo.religiousName} onChange={onCaseChange}   />
                        </div>
                    </div>} 
                   
                    
                <div  style={{display:'flex'}}>
                    <JisCheckbox label="Check this box if you have FIAT  to this case" value={isFiat} onChange={(e)=>setIsFiat(e)} />
                    {isFiat && <div className="btn-upload" >
                        <input type="file" name="fiatdoc" accept="application/pdf" id={`file-fiat`} 
                        onChange={(e) => handleUploadChange(e)}/>
                        <label htmlFor={`file-fiat`} title={fiat?.name}>{fiat==null?'Click to upload FIAT document': Constants.ReduceString(fiat?.filename, 30)  }</label>
                        {fiat!=null && <JisButton onClick={()=>setIsPreview(true)} icon='preview'>Preview Fiat Document</JisButton>} 
                        {fiat==null && <div style={{color:'red'}}>*</div> } 
                    </div>}    
                </div>        

            </div>
           
        </div>
        <div style={{display:'flex'}}>
            <div style={{flex:1}}>
                <div  style={{display:'flex'}}>
                    <div  className="input-group">
                        <label>Number of Witnesses  <span className="required">*</span> </label>
                        <div className='input-wrapper'>
                            <DynamicIcon iname="group" />
                            <input placeholder='Number of Witnesses' required={true} name="witness" type='number' value={cinfo.witness} onChange={onCaseChange}   />
                        </div>
                    </div>
                    <div className="select-group">
                            <label> Division <span className="required">*</span> </label>
                            <select name="divisionId" value={cinfo.divisionId} required={true} onChange={onCaseChange} >
                                <option value="">Select </option>
                                {frequentData?.divisions.map((opt) => (
                                <option key={opt.id} value={opt.id}>
                                    {opt.title}
                                </option>
                                ))}
                            </select>
                            </div>
                 <div className="select-group">
                            <label> Case Identity <span className="required">*</span> </label>
                            <select name="isPublic" value={cinfo.isPublic} required={true} onChange={onCaseChange} >
                               
                                {caseidentity.map((opt) => (
                                <option key={opt.value} value={opt.value}>
                                    {opt.label}
                                </option>
                                ))}
                            </select>
                            </div>        
                </div>

              

                <div style={{display:'flex'}}>
                         <div className="select-group">
                            <label> State <span className="required">*</span></label>
                            <select name="stateId" required={true} value={cinfo.stateId} onChange={onCaseChange} >
                               {locs.state==null  && <option value="">Select state</option>}
                                {locs.state==false && <option value="">loading state</option>}
                                {locs.state  && <option value="">Select state</option>}

                                {states.map((opt) => (
                                <option key={opt.id} value={opt.id}>
                                    {opt.title}
                                </option>
                                ))}
                            </select>
                            </div>
                        <div className="select-group">
                            <label> L.G.A <span className="required">*</span></label>
                            <select  name="LocalGovtAreaId" value={cinfo.LocalGovtAreaId} required={true} onChange={onCaseChange}>
                                {locs.lga==null  && <option value="">Select State first</option>}
                                {locs.lga==false && <option value="">loading LG</option>}
                                {locs.lga  && <option value="">Select LG</option>}


                                {Lga.map((opt) => (
                                <option key={opt.id} value={opt.id}>
                                    {opt.title}
                                </option>
                                ))}
                            </select>
                            </div>
                       <div className="select-group">
                            <label> City <span className="required">*</span></label>
                            <select  name="cityId" value={cinfo.cityId} required={true} onChange={onCaseChange}>
                                {locs.city==null  && <option value="">Select LGA first</option>}
                                {locs.city==false && <option value="">loading cities</option>}
                                {locs.city && <option value="">Select city</option>}
                                {cities.map((opt) => (
                                <option key={opt.id} value={opt.id}>
                                    {opt.title}
                                </option>
                                ))}
                            </select>
                            </div>
                    </div> 
                <div>
                   

                
                </div>
            </div>
          
        </div>
 <div style={{ margin:'auto'}}>
            <div>
                <h2>Select Option(s)</h2>
                <p>Check the option(s) applicable from below: </p>
            </div>
            



            <div style={{display:'flex', marginBottom:18, marginTop:18}}>
                 <JisYesNo  label="Is Declarative Order Sought?" value={cinfo.isDelarative} onChange={(e)=> setCase({...cinfo, isDelarative:e})}/>   

                <JisYesNo label="Does the case require Legal Interpretation?" value={cinfo.isRequireInterpretation} onChange={(e)=> setCase({...cinfo, isRequireInterpretation:e})} />
            </div>
            <div style={{display:'flex', marginBottom:18}}>
                <JisYesNo label="Is legal policy or constitutional issues that necessitate a binding and public precedent involved?" 
                value={cinfo.isLegalPolicy} onChange={(e)=> setCase({...cinfo, isLegalPolicy:e})} />
                <JisYesNo label="Is declaration of the legal position or interpretation of an instrument or policy document involved?"
                 value={cinfo.isLegalPosition} onChange={(e)=> setCase({...cinfo, isLegalPosition:e})} />
            </div>
            <div style={{display:'flex', marginBottom:18}}>
                <JisYesNo label="Is emergency injunctive relief sought or party needed to maintain status quo?"
                 value={cinfo.isEmergency} onChange={(e)=> setCase({...cinfo, isEmergency:e})} />
                <JisYesNo label="Does the dispute significantly affect non-parties?" 
                value={cinfo.isDispute} onChange={(e)=> setCase({...cinfo, isDispute:e})} />
            </div>
            <div style={{display:'flex', marginBottom:18}}>
                <JisYesNo label="Is there a need for uniform treatment towards an issue or disputant?" 
                value={cinfo.isUniform} onChange={(e)=> setCase({...cinfo, isUniform:e})}/>
                
            </div>
           
            
            </div> 

 
        <div>
             <h2>Cause Of Action</h2>
             <div style={{display:'flex', flexDirection:'row'}}>
                    
                    <div style={{flex:1}}>
                        <p>For additional cause of action not listed, please click the "Add other Causes" button below:</p>
 {otherCauses?.map((opt, index) => (
                    <div key={index} className={`cause-item ${removingIndex === index ? 'removing' : ''}`}>
                        <div className="input-group">
                        <label>
                            Other Cause Of Action {index + 1} <span className="required">*</span>
                        </label>
                        <div className="input-wrapper">
                            <DynamicIcon iname="group" />
                            <input
                            placeholder="Enter Cause of Action"
                            required
                            value={opt.description}
                            onChange={(e) => onChangeOtherCause(index, 'description', e.target.value)}
                            />
                        </div>
                        </div>
                        <div onClick={() => onRemoveOtherCause(index)} className='delete'>
                        <DynamicIcon iname="trash-2" /> Delete
                        </div>
                    </div>
                    ))}
                  <JisButton icon="add" onClick={onAddOtherCause}>Add Other Causes</JisButton>   
                    </div>
             </div>
        

               
               
               
<div className='flowerror'>{flowerror}</div>
        </div>
         <div className='flowbuttongroup'>
             <JisButton type='submit'>Save Update</JisButton>
         </div>
        </form>
        
        </div>} 
{tab=="caseno" && <div  className='tab_view'>
  <div>
    <h3>Change of Case Number</h3>
    <div>
        <p style={{color:'red'}}>Warning: Changing the case number may affect the integrity of the case data and should be done with caution. Please ensure that all relevant parties are informed of the change.</p>
        <div>
          <JisCheckbox label="I want to manually set the Case Number" value={isNewCaseNumber==null?false:isNewCaseNumber} onChange={(e)=> setIsNewCaseNumber(true)} />
           <JisCheckbox label="I want new system generated Case number" value={isNewCaseNumber==null?false:!isNewCaseNumber} onChange={(e)=> setIsNewCaseNumber(false)} />  
        </div>
      </div>
  {isNewCaseNumber==true &&   <form onSubmit={onSubmitCaseNumber}>
       <div  className="input-group">
            <label>The Current Case Number <span className="required">*</span> </label>
            <div className='input-wrapper'>
                <DynamicIcon iname="newspaper" />
                <input placeholder='Current Case Number' required={true} 
                name="oldCaseNumber" maxLength={20} value={changeNumber.oldCaseNumber} 
                onChange={(e)=> setChangeNumber({...changeNumber,oldCaseNumber:e.target.value})}   />
            </div>
        </div>

         <div  className="input-group">
            <label>The New Case Number <span className="required">*</span> </label>
            <div className='input-wrapper'>
                <DynamicIcon iname="newspaper" />
                <input placeholder='New Case Number' required={true} 
                name="newCaseNumber" maxLength={20} value={changeNumber.newCaseNumber} 
                onChange={(e)=> setChangeNumber({...changeNumber,newCaseNumber:e.target.value})}   />
            </div>
        </div>
        
        <div className='flowerror'>{flowerror}</div>
        <div className='flowbuttongroup'>
             <JisButton type='submit'>Manual Change Case Number</JisButton>
         </div>
    </form>}
     {isNewCaseNumber==false &&   <form onSubmit={onSubmitCaseNumber}>
       <div  className="input-group">
            <label>The Current Case Number <span className="required">*</span> </label>
            <div className='input-wrapper'>
                <DynamicIcon iname="newspaper" />
                <input placeholder='Current Case Number' required={true} 
                name="oldCaseNumber" maxLength={20} value={changeNumber.oldCaseNumber} 
                onChange={(e)=> setChangeNumber({...changeNumber,oldCaseNumber:e.target.value})}   />
            </div>
        </div>
         <p style={{color:'red'}}>Warning: The system will generate the new Case Number based on the current numbering system.</p>

        <div className='flowerror'>{flowerror}</div>
        <div className='flowbuttongroup'>
             <JisButton type='submit'>Auto Change Case Number</JisButton>
         </div>
    </form>}

  </div>
  </div>}
  {tab=="casestatus" && <div  className='tab_view'>
  <div>
    <h3>Change of Case Status <strong>{
                    Constants.getItemById(
                      frequentData?.casestatuses,
                      cinfo?.caseStatusId,
                    )?.description
                  }</strong></h3>
    <form onSubmit={onSubmitCaseStatus}>
       
              <div className="select-group">
                  <label> New Case Status <span className="required">*</span> </label>
                  <select name="newStatus" value={changeStatus.newStatus} required={true} 
                  onChange={(e)=> setChangeStatus({...changeStatus,newStatus:e.target.value})} >
                      <option value="">Select </option>
                      {frequentData?.casestatuses.map((opt) => (
                      <option key={opt.id} value={opt.id}>
                          {opt.description}
                      </option>
                      ))}
                  </select>
                  </div>
        

        <div className='flowerror'>{flowerror}</div>
        <div className='flowbuttongroup'>
             <JisButton type='submit'>Change Case Status</JisButton>
         </div>
    </form>
  </div>
  </div>}
  {tab=="uploadoptions" && <div className='tab_view'>
    <h3>Document Upload Options</h3>
    <p style={{ fontSize: 13, opacity: 0.8, marginBottom: 12 }}>
      Reset a document whose upload option was selected by mistake. The Legal Counsel/Customer can then
      choose the correct option and upload the document again. Commissioned filings can no longer be reset.
    </p>
    {uploadFees.length === 0 && <div>No uploaded filing documents on this case.</div>}
    {uploadFees.map((fee) => (
      <div key={fee.id} className="table" style={{ marginBottom: 16 }}>
        <div className="section-cases">
          <span>
            {fee.feeType} - filed by {fee.createdBy} on {Constants.momentDate(fee.createdOn)?.format("DD MMM, YYYY")}
            {fee.isCommissioned && <strong> (Commissioned)</strong>}
          </span>
        </div>
        <div className="table-wrapper">
          <table className="case-table">
            <thead>
              <tr>
                <th className="col-title">Document</th>
                <th className="col-title">Upload Option Selected</th>
                <th className="col-medium">Uploaded On</th>
                <th className="col-medium">Status</th>
                <th className="col-action">Action</th>
              </tr>
            </thead>
            <tbody>
              {fee.uploads.flatMap((u) => u.lines).map((line) => (
                <tr key={line.id}>
                  <td>{line.documentTitle}</td>
                  <td>
                    {line.uplineType ? UPLOAD_OPTION_LABELS[line.uplineType] || line.uplineType : "Not selected"}
                    {line.uplineType === "template" && line.selectedTemplate && (
                      <div style={{ fontSize: 11, opacity: 0.75 }}>{line.selectedTemplate.split("|")[1] || line.selectedTemplate}</div>
                    )}
                  </td>
                  <td>{line.uploadDate ? Constants.momentDate(line.uploadDate)?.format("DD MMM, YYYY") : "N/A"}</td>
                  <td>{line.isCompleted ? "Processed" : line.uploadDate ? "Awaiting processing" : "Awaiting upload"}</td>
                  <td>
                    {fee.canReset && (line.uplineType || line.uploadDate) ? (
                      <JisButton variant="plain" onClick={() => { setResetLine(line); setResetReason(""); setResetError(""); }}>
                        Reset Option
                      </JisButton>
                    ) : (
                      "-"
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    ))}
  </div>}
  {tab=="caseflags" && <div className='tab_view'>
  <div>
    <h3>Case State</h3>
    <p style={{ fontSize: 13, opacity: 0.8, marginBottom: 12 }}>
      Active: <strong>{cinfo?.isActive ? "Yes" : "No"}</strong> &nbsp;|&nbsp; Concluded:{" "}
      <strong>{cinfo?.isConcluded ? "Yes" : "No"}</strong>
      {cinfo?.isConcluded && cinfo?.concludedOn && (
        <> (on {Constants.momentDate(cinfo.concludedOn)?.format("DD MMM, YYYY")})</>
      )}
    </p>
    <form onSubmit={onSubmitCaseFlags}>
      <div style={{ display: "flex", gap: 16, flexWrap: "wrap" }}>
        <div className="select-group" style={{ minWidth: 220 }}>
          <label>Case is Active</label>
          <select value={caseFlags.isActive} onChange={(e) => setCaseFlags({ ...caseFlags, isActive: e.target.value })}>
            <option value="yes">Yes - case is live on the system</option>
            <option value="no">No - case is deactivated/hidden</option>
          </select>
        </div>
        <div className="select-group" style={{ minWidth: 220 }}>
          <label>Case is Concluded</label>
          <select value={caseFlags.isConcluded} onChange={(e) => setCaseFlags({ ...caseFlags, isConcluded: e.target.value })}>
            <option value="no">No - case is ongoing</option>
            <option value="yes">Yes - case is concluded</option>
          </select>
        </div>
      </div>
      <div className="input-group">
        <label>Reason for the change <span className="required">*</span></label>
        <textarea
          rows={3}
          value={caseFlags.reason}
          maxLength={500}
          onChange={(e) => setCaseFlags({ ...caseFlags, reason: e.target.value })}
          placeholder="Why is this case being activated/deactivated or (un)concluded?"
        />
      </div>
      <div className='flowerror'>{flagError}</div>
      <div className='flowbuttongroup'>
        <JisButton type='submit' disabled={!flagsChanged}>Save Case State</JisButton>
      </div>
    </form>
  </div>
  </div>}
      {tab=='caseclaims' &&  <div className='tab_view'>

        {claims.length>0 && <div  className='table'>
            <div class="section-cases">
                <span>Claim to the case</span><span className='total'>{claims.length}</span>
            </div>
            <table  class="case-table">
            <tr>
                <th> {cinfo.caseTypeId == 2 ? 'Offence' : 'Claim'}</th>
                <th>Currency Type </th>
                <th className="col-title">Value</th>
                <th className="col-title">Party</th>
                <th>Status</th>
                <th>Action</th>
            </tr>
            {claims?.map((opt,index) => (
                <tr key={index}>
                    <td>{opt.claim}</td>
                    <td>{opt.currencyType}</td>
                    <td>{opt.claimValue}</td>
                     <td> {Constants.getItemById(parties,opt.partyId)?.firstName} {Constants.getItemById(parties,opt.partyId)?.lastName??''}</td>
               <td>{opt.isActive?'Active':'Inactive'}</td>
                    <td>
                     <div className='groupbtn'>
                       <JisButton  variant='plain' icon="edit" onClick={()=>onEditClaim(opt,index)}>Edit</JisButton> 
                       {/*  <JisButton variant='plain' icon="trash-2" onClick={()=>onRemoveClaims(index)}>Remove</JisButton> */}
                      </div>
                      </td>
                </tr>
                                
            ))}
            </table> 
            
        </div>}

          
<div style={{ textAlign: "right" }}>
         <JisButton onClick={onNewClaim}>
                  Add {cinfo.caseTypeId == 2 ? 'Offence' : 'Claim'}
               </JisButton> 
        </div> 
        
       
        </div>}    
      {tab=='parties' && <div className='tab_view'>
         
     <JisButton onClick={onAddNewParty}>
                  Add Party
               </JisButton>   
          {parties.length> 0 && 
          <div className='table'>
            <div class="section-cases">
              <span>Parties to the case</span><span className='total'>{parties.length}</span>
            </div>
              <table  class="case-table">
            <tr>
                <th>Name</th>
                <th>Party Type</th>
                <th>Phone Number</th>
                <th>Email</th>
                <th>Lead</th>
                <th>Address</th> 
                <th>Status</th>
                <th>Action</th>
            </tr>
            {parties?.map((opt,index) => (
                <tr key={index}>
                    <td>{`${opt.firstName} ${opt.lastName??''}`}</td>
                    <td>{Constants.getItemById(frequentData?.partyTypes,opt.partyTypeId)?.title} </td>
                    <td>{opt.primaryContactNumber}</td>
                    <td>{opt.primaryEmail}</td>
                    <td>{opt.isLeadParty?'Yes':'No'}</td>
                    <td>{opt.address1}</td>
                    <td>{opt.isActive?'Active':'Inactive'}</td>
                    <td>
                     <div className='groupbtn'>
                       <JisButton  variant='plain' icon="edit" onClick={()=>onEditParty(opt,index)}>Edit</JisButton> 
                    <JisButton variant='plain' icon="trash-2" onClick={()=>onRemoveParty(index)}>Remove</JisButton>
                      </div></td>
                </tr>
             ))}
            </table>   
            </div>}  
        </div>}  
      {tab=='motions' &&  <div className='tab_view'>
       
      <div>
        
            
                {motions.length> 0 && 
                <div className='table'>
            <div class="section-cases">
              <span>Motion</span><span className='total'>{motions.length}</span>
            </div>
                    <table  class="case-table">
                    <tr>
                        <th>Party</th>
                        <th>Application Classification</th>
                        <th>Application Type</th>
                        <th>Prayers</th>
                        <th>Status</th>
                        <th>Action</th>
                    </tr>
                    {motions?.map((opt,index) => (
                        <tr key={index}>
                            <td>{Constants.getItemById(partyOptions,opt.partyId)?.firstName} {Constants.getItemById(partyOptions,opt.partyId)?.lastName??''}</td>
                            <td>{Constants.getItemById(frequentData?.motionclass,opt.motionClassificationId)?.title}</td>
                            <td>{Constants.getItemById(frequentData?.motiontypes,opt.motionTypeId)?.title}</td>
                            <td>
                                <ol>
                                    {opt.prayers?.map((pray,ind) => (
                                        <li key={ind}>{pray.prayer}</li>
                                    ))}
                                </ol>
                            </td>
                        <td>{opt.isActive?'Active':'Inactive'}</td>
                            <td> <div style={{display:'flex'}}> <JisButton icon="edit" variant='plain' onClick={()=>onEditMotion(opt,index)}>Edit</JisButton> 
                         {/*    <JisButton icon="close" variant='plain' onClick={()=>onRemoveMotion(index)}>Remove</JisButton> */}
                                </div></td>
                        </tr>
                                        
                       ))}
                    </table>   
                </div>}   

        </div> 
       <div style={{ textAlign: "right" }}>
          <button className="btn-solid add-motion-btn" onClick={onNewMotion}>
            File a new motion
          </button>
        </div> 
             
       <div>

       </div>
        
        </div>
        } 
      {tab=='casedocuments' &&  <div className='tab_view'>
       
             <div className="table">
        <div class="table-header">
          <p>Case Documents</p>
        </div>

        <div className="table-wrapper">
          <table className="case-details-table full-border">
            <thead>
              <tr>
                <th>Title</th>

                <th>Party</th>
                <th>Filed On</th>
                <th>Status</th>
                <th>Preview</th> 
                <th>Action</th>
                
              </tr>
            </thead>
            <tbody>
              {documents?.map((opt) => (
                <tr>
                  <td>{opt.title || "N/A"}</td>

                  {opt.party != null ? (
                    <td>
                      {" "}
                      {opt.party?.firstName || opt.party?.lastName
                        ? `${opt.party?.firstName} ${opt.party?.lastName ?? ""}`
                        : "N/A"}
                    </td>
                  ) : (
                    <td>
                      {opt.doneBy?.firstName || opt.doneBy?.lastName
                        ? `${opt.doneBy?.firstName} ${
                            opt.doneBy?.lastName ?? ""
                          }`
                        : "N/A"}
                    </td>
                  )}
                  <td>
                    {opt.createdOn
                      ? Constants.momentDate(opt.createdOn).format(
                          "DD MMM, YYYY"
                        )
                      : "N/A"}
                  </td>
                  {/* {opt.documentLocation != "template" ? (
                    <td
                      className="schedule-zoom"
                      onClick={() => onDownload(opt)}
                    >
                      {" "}
                      Download <DynamicIcon iname="download" />{" "}
                    </td>
                  ) : (
                    <td className="schedule-zoom">
                      {" "}
                      <Link
                        target="_blank"
                        to={`/template-live-document/${opt.id}`}
                      >
                        Print/Save <DynamicIcon iname="print" />{" "}
                      </Link>
                    </td>
                  )} */}
                  <td>{opt.isActive?'Active':'Inactive'}</td>
                  <td>
                    <JisButton
                      variant="plain"
                      onClick={() => onPreviewDoc(opt)}
                    >
                      Preview
                    </JisButton>
                    
                  </td>
                  <td>
                    <JisButton
                      variant="plain"
                      onClick={() => PrepareDocumentRemove(opt)}
                    >
                      {opt.isActive?'Remove':'Restore'} Document
                    </JisButton>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

      </div>
      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <div style={{display:'flex', width:'fit-content', gap: '10px'}}>
            <button
              className="btn-solid add-addition-document-btn"
              onClick={onAddUpline}
            >
              + Additional Document
            </button>
          </div>
          
        </div>
        <p>Document uploading section</p>
<div className="table-wrapper">
  <form onSubmit={onUploadUplines}>
    <table className="case-details-table full-border">
    <thead>
      <tr>
        <th>Document Title</th>
        <th>Party</th>
        <th>File</th>
        <th>Action</th>
      </tr>
    </thead>
    <tbody>
      {uplines.map((upline, index) => (
        <tr key={index}>
          <td>
            <input
              type="text"
              placeholder="Document Title"
              required
              value={upline.DocumentTitle}
              onChange={(e) => {
                const newUplines = [...uplines];
                newUplines[index].DocumentTitle = e.target.value;
                setUplines(newUplines);
              }}
            />
            
          </td>
          <td>
          
            <select  value={upline.partyId} required={true} 
             onChange={(e) => {
                const newUplines = [...uplines];
                newUplines[index].partyId = e.target.value;
                setUplines(newUplines);
              }}>
                <option value="">Select Party</option>
              {parties?.map((opt,index) => (
                <option key={index} value={opt.id}>
                   {`${opt.firstName} ${opt.lastName??''}`}
                </option>
             ))}
            </select>
            
          </td>
          <td>
            <input
              type="file"
              accept="application/pdf"
              required
              onChange={(e) => {
                const newUplines = [...uplines];
                newUplines[index].file = e.target.files[0];
                setUplines(newUplines);
              }}
            />
          </td>
          <td>
            <button onClick={() => onRemoveUpline(index)} >Remove</button>
          </td>
        </tr>
      ))}
    </tbody>
  </table>
  <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <div style={{display:'flex', width:'fit-content', gap: '10px'}}>
            <button className="btn-solid add-addition-document-btn" type='submit' disabled={uplines.length==0} >
              Upload documents ({uplines.length})
            </button>
          </div>
          
        </div>
  </form>
  
</div>
        </div>} 
       
      </div>
      <BackLoader open={loading} />
    {showLegals && 
      <JisDialogForm onClose={onCloseLegals}>
        <div>List all available arthoney attached to the Firm</div>
      </JisDialogForm>} 

      { openClaim && <JisDialogForm title={` ${claim.id>0?'Modify':'New'} Claim`}  onClose={()=> onCancelAction('claim')}>
        <div>
        <form onSubmit={onSaveClaims}>
           <div style={{marginTop:30}}>
            <h2> {cinfo.caseTypeId == 2 ? 'Offence' : 'Claim'}</h2>
                <div className={`claim-item`}>
                  <div style={{ flex: 1 }}>
                <div  className="select-group">
                <label> Party </label>
                <select  value={claim.partyId} name="partyId" required={true} 
                    onChange={onChangeClaim}>
                        <option value="">Select Party</option>
                      {parties?.map((opt,index) => (
                        <option key={index} value={opt.id}>
                          {`${opt.firstName} ${opt.lastName??''}`}
                        </option>
                    ))}
                    </select>
                
                 </div>
                  </div>
                    <div style={{ flex: 1 }}>
                    
                    <div  className="input-group">
                            <label> {cinfo.caseTypeId == 2 ? 'Offences' : 'Claims'} <span className="required">*</span> </label>
                            <div className='input-wrapper'>
                                <DynamicIcon iname="group" />
                                <textarea placeholder='e.g Money Laundering' required={true} name='claim'  value={claim.claim}
                        onChange={onChangeClaim}   />
                            </div>
                        </div>

                {cinfo.caseTypeId != 2 && <div style={{ display: 'flex', gap: 8 }}>
                        
                        <div className="select-group">
                            <label>
                                Currency Type 
                            </label>
                            <select name="currencyType"  value={claim.currencyType}
                        onChange={ onChangeClaim} >
                                <option value="">Select </option>
                                {currencies.map((opt) => (
                                <option key={opt.value} value={opt.value}>
                                    {opt.label}
                                </option>
                                ))}
                            </select>
                        </div>

                        <div  className="input-group">
                            <label> Claim Value (Numbers only) </label>
                            <div className='input-wrapper'>
                                <DynamicIcon iname="money" />
                                <input required={claim.claimValue} name='claimValue'  placeholder="eg 300" 
                                value={Constants.formatCurrency(claim.claimValue) }
                                onChange={ onChangeClaim}  />
                            </div>
                        </div>
                    
                    </div>} 
                    <JisCheckbox
                      label="Uncheck to Disable the claim"
                      value={claim.isActive}
                      onChange={(e) => setClaim({ ...claim, isActive: e })}
                    /> 
                    </div>
                   
                </div>
            </div>
                    <div className='flowbuttongroup'>
                        <JisButton variant='outline' onClick={()=>onCancelAction('claim')}>Cancel</JisButton>
                        <JisButton type='submit' loading={loading}>Update</JisButton>
                    </div> 
        </form>
        </div>

      </JisDialogForm>}

    {openMotion && <JisDialogForm title={` ${motion.id>0?'Modify':'New'} Motion`}  onClose={()=> onCancelAction('motion')}>
        <div>
<form onSubmit={onSaveMotion}>
            <div>
                                <div className="select-group">
                                            <label>Select Party </label>
                                                    <select name="partyId" value={motion.partyId} required onChange={onMotionChange} >
                                                        <option value="">Select </option>
                                                        {parties
                                                            //?.filter(opt => opt.partyTypeId == Constants.ClaimantType)
                                                            .map((opt, index) => (
                                                                <option key={index} value={opt.id}>
                                                                {opt.firstName} {opt.lastName??''}
                                                                </option>
                                                            ))}
                                                                                                                
                                                            
                                                            </select>
                                 </div>
                                <div style={{display:'flex'}}>
                                    <div className="select-group">
                                            <label> Motion/Application classification </label>
                                                    <select name="motionClassificationId" value={motion.motionClassificationId} required onChange={onMotionChange} >
                                                        <option value="">Select </option>
                                                        {frequentData?.motionclass?.map((opt) => (
                                                        <option key={opt.id} value={opt.id}>
                                                            {opt.title}
                                                        </option>
                                                        ))}
                                                    </select>
                                    </div>
                                    <div className="select-group">
                                            <label> Motion/Application Type  </label>
                                                    <select name="motionTypeId" value={motion.motionTypeId} required  onChange={onMotionChange} >
                                                        <option value="">Select </option>
                                                        {frequentData?.motiontypes?.filter(opt => opt.filingTypeId == cinfo.caseFilingId)
                                                        .map((opt) => (
                                                        <option key={opt.id} value={opt.id}>
                                                            {opt.title}
                                                        </option>
                                                        ))}
                                                    </select>
                                     </div>        
                                </div>
                                <div>
                                    {motionPrayers?.map((pray, index) => (
                                <div key={index} className={`claim-item ${removingIndex === index ? 'removing' : ''}`}>
                                    <div style={{ flex: 1 }}>
                                    
                                    <div  className="input-group">
                                            <label>Particulars of Prayers Sought <span className="required">*</span> </label>
                                            <div className='input-wrapper'>
                                                <DynamicIcon iname="group" />
                                                <textarea placeholder=' Particulars of Prayers Sought' required={true}  value={pray.prayer}
                                        onChange={(e) => onChangePrayer(index, 'prayer', e.target.value)}   />
                                            </div>
                                        </div>
                    
                                    </div>
                                    <div className='delete' onClick={() => onRemovePrayer(index)}>
                                    <DynamicIcon iname="trash-2" /> <span>Delete</span>
                                    </div>
                                </div>
                            ))}
                                <JisButton icon="add" onClick={onAddPrayer}>Add Prayer</JisButton>

                                    </div>
                                    <JisCheckbox
                      label="Disable the Motion"
                      value={motion.isActive}
                      onChange={(e) => setMotion({ ...motion, isActive: e })}
                    /> 
                            <div className='flowerror'>{flowerror}</div>
                              <div className='flowbuttongroup'>
                                <JisButton variant='outline' onClick={()=>onCancelAction("motion")}>Cancel</JisButton>
                                <JisButton type='submit' >Save</JisButton>
                            </div>
                            </div>
        </form>
        </div>
      </JisDialogForm>}

     {openParty && <JisDialogForm title="Party details"  onClose={()=> onCancelAction('party')}>
      <JisParty onSave={onSaveParty} defaultParty={party} />
      </JisDialogForm>}  

     
{isSaved && <JisDialog title={savedTitle} >
        <div>Save successfully. Contnue to modify in other tab. When you done, just continue with back button</div>
            <JisButton onClick={()=>setIsSaved(false)} >Ok</JisButton>
      </JisDialog>}

      {isChange && <JisDialog title="Change Case Number" >
        <div> Are you sure you want to change the Case Number? Click Continue or Cancel to return</div>
            <JisButton onClick={onChangeCaseNumber} >Continue</JisButton>
             <JisButton onClick={()=>setIsChange(false)} >Cancel</JisButton>
      </JisDialog>}
 {resetLine && <JisDialogForm title="Reset Upload Option" onClose={() => setResetLine(null)}>
        <div style={{ padding: 16 }}>
          <p>
            Reset the upload option of <strong>{resetLine.documentTitle}</strong>
            {resetLine.uplineType && <> (currently: {UPLOAD_OPTION_LABELS[resetLine.uplineType] || resetLine.uplineType})</>}?
            The uploaded file/template is detached and the filer must select the correct option and upload again.
          </p>
          <div className="input-group">
            <label>Reason <span className="required">*</span></label>
            <textarea rows={3} maxLength={500} value={resetReason}
              onChange={(e) => setResetReason(e.target.value)}
              placeholder="e.g. Counsel selected 'already attested' instead of 'to be attested'" />
          </div>
          <div className='flowerror'>{resetError}</div>
          <div className='flowbuttongroup'>
            <JisButton onClick={onConfirmResetUpload}>Reset Option</JisButton>
            <JisButton variant="outline" onClick={() => setResetLine(null)}>Cancel</JisButton>
          </div>
        </div>
      </JisDialogForm>}
 {isFlags && <JisDialog title="Change Case State" >
        <div> Are you sure you want to set this case to Active: <strong>{caseFlags.isActive === "yes" ? "Yes" : "No"}</strong>,
          Concluded: <strong>{caseFlags.isConcluded === "yes" ? "Yes" : "No"}</strong>? Click Continue or Cancel to return</div>
            <JisButton onClick={onSaveCaseFlags} >Continue</JisButton>
             <JisButton onClick={()=>setIsFlags(false)} >Cancel</JisButton>
      </JisDialog>}
 {isStatus && <JisDialog title="Change Case Status" >
        <div> Are you sure you want to change the Case Status? Click Continue or Cancel to return</div>
            <JisButton onClick={onChangeStatus} >Continue</JisButton>
             <JisButton onClick={()=>setIsStatus(false)} >Cancel</JisButton>
      </JisDialog>}

 {isDocument && <JisDialog title={doc?.isActive?"Remove Document":'Restore Document'} >
        <div> Are you sure you want to {doc?.isActive?'Remove':'Restore'} this document? Click Continue or Cancel to return</div>
            <JisButton onClick={onRemoveDocument} >Continue</JisButton>
             <JisButton onClick={()=>setIsDocument(false)} >Cancel</JisButton>
      </JisDialog>}

      {isPreview && <div className={  "preview open" } style={{overflow:'scroll'}}>
                <div className="heading">
                  <div>
                    <JisButton icon="close"  onClick={() => setIsPreview(false)}> Close Preview</JisButton>
                     </div>
                  
                </div>
               <PdfViewer   pdfUrl={previewUrl}/>
               
                
                <div className="date-btns">
                    
                  
                </div>
            </div>} 

           
    </div>
  );
}

export default Historical_Case;